import DashboardIcon from "@mui/icons-material/Dashboard";
import DomainAddIcon from "@mui/icons-material/DomainAdd"; // (clinic setup/expansion)
import GroupIcon from "@mui/icons-material/Group";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import MenuIcon from "@mui/icons-material/Menu";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  AppBar,
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import arroe from "../assets/panel-arrow.svg";
import scanologo from "../assets/scanologo.png";
import scanologoWhite from "../assets/scanOLogoWhite.png";
import PageLoader from "../components/Loader";
import Title from "../components/PageTitle";
import { useToast } from "../components/Toast";
import useIsMobile from "../Hooks/useIsMobile";
import apiService from "../Services/api.service";
import OverAllDaywise from "../components/OverAllDaywise";
import OverAllMonthwise from "../components/OverAllMonthwise";
const drawerWidth = 220;

const Dashboard = () => {
  const location = useLocation();
  const isMobile = useIsMobile();
  const [drawerOpen, setDrawerOpen] = useState(false); // State for mobile drawer visibility
  const [userCount, setUserCount] = useState([]);
  const [scanCount, setScanCount] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const entityId = localStorage.getItem('entityId');
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };
  const navigate = useNavigate();
  //const isMobile = useIsMobile();
  const [Loader, isLoader] = useState(false);
  const theme = useTheme();
  const token = localStorage.getItem("token");
  const Toast = useToast();
  const menuItems = [
    { text: "Dashboard", icon: <DashboardIcon />, path: "/dashboard" },
    {
      text: "Doctor",
      icon: <HealthAndSafetyIcon />,
      path: "/dashboard/doctor",
    },
    { text: "Clinic", icon: <DomainAddIcon />, path: "/dashboard/Clinic" },

    {
      text: "Patients",
      icon: <GroupIcon />,
      path: "/dashboard/user",
    },

    { text: "Settings", icon: <SettingsIcon />, path: "/dashboard/settings" },
  ];

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };
  useEffect(() => {
    if (!token) {
      isLoader(true);
    } else {
      getAllCounts();
    }
  }, [token]);
  // Check if the current path is the login page
  const isLoginPage = location.pathname === "/login";

  const getAllCounts = async () => {
    isLoader(true);
    try {
      const auth = token;
      const mapped = await apiService.getCounts(
        auth,
        entityId
      );
      isLoader(false);
      console.log("mapped", mapped);
      setUserCount(mapped.count.userCount);
      setScanCount(mapped.count.scanCount);
    } catch (error) {
      isLoader(false);
      console.log("errrrrr getDoctors", error);
      Toast.error("Error while Fetching kiosk");
    } finally {
      isLoader(false);
    }
  };
  const InfoCard = ({ title, count, description, onClick, bgColor }) => (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: "background.paper",
        boxShadow: 3,
        borderRadius: 2,
        p: 4,
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
        transition: "all 0.3s ease",
        width: "100%",
        height: "100%%",
        "&:hover": { transform: "scale(1.05)", boxShadow: 6 },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: isMobile ? -20 : -30,
          right: -25,
          width: isMobile ? 100 : 150,
          height: isMobile ? 100 : 150,
          backgroundColor: bgColor,
          borderRadius: "50%",
          opacity: 0.3,
          zIndex: 0,
        }}
      />
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <Typography variant="h6" fontWeight="bold" color="text.secondary">
          {title}
        </Typography>
        <Typography variant="h3" color="primary.main" fontWeight="bold" mt={2}>
          {count}
        </Typography>
        <Typography variant="body2" color="text.secondary" mt={1}>
          {description}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: "flex" }}>
      {/* Conditionally render AppBar and Drawer based on the current path */}
      {!isLoginPage && isMobile && (
        <AppBar
          position="fixed"
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={toggleDrawer}
              sx={{ display: { sm: "none" } }} // Show hamburger menu on mobile only
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap component="div">
              scanO
            </Typography>
          </Toolbar>
        </AppBar>
      )}

      {/* Permanent Drawer for Desktop */}
      {!isLoginPage && (
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            [`& .MuiDrawer-paper`]: {
              width: collapsed ? "60px" : drawerWidth,
              transition: "width 0.3s",
              overflowX: "hidden",
              boxSizing: "border-box",
              backgroundColor: "#0B0C10",
            },
          }}
        >
          <Box
            sx={{
              background: "#70707080",

              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.4)", // Optional shadow
              display: "flex",
              justifyContent: collapsed ? "center" : "right",
              padding: 1,
              margin: collapsed ? "10%" : "0",
              marginLeft: !collapsed ? "80%" : "10%",

              marginTop: 1,
              borderRadius: 2,
            }}
            onClick={toggleSidebar}
          >
            <img
              src={arroe} // Replace with your arrow SVG
              alt="toggle"
              width={20}
              height={20}
              style={{
                transform: collapsed ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.6s",
              }}
            />
          </Box>
          <List>
            {/* Logo */}
            {!collapsed && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "left",
                  marginBottom: 2,
                  marginLeft: 2,
                }}
              >
                <img src={scanologoWhite} width={100} height={45} alt="Logo" />
              </Box>
            )}

            {/* Menu Items */}
            {menuItems.map((item) => (
              <ListItem
                key={item.text}
                component={Link}
                to={item.path}
                selected={location.pathname === item.path}
                sx={{
                  borderRadius: "8px",
                  backgroundColor:
                    location.pathname === item.path ? "#fff" : "transparent",
                  color:
                    location.pathname === item.path
                      ? (theme) => theme.palette.primary.main
                      : "#fff",
                  borderLeft:
                    location.pathname === item.path
                      ? `4px solid ${(theme) => theme.palette.primary.main}`
                      : "none",
                  "&:hover": {
                    backgroundColor:
                      location.pathname === item.path ? "#fff" : "#1F2833",
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    color:
                      location.pathname === item.path
                        ? (theme) => theme.palette.primary.main
                        : "#fff",
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                {!collapsed && <ListItemText primary={item.text} />}
              </ListItem>
            ))}
          </List>
        </Drawer>
      )}

      {/* Temporary Drawer for Mobile */}
      {!isLoginPage && (
        <Drawer
          variant="temporary"
          open={drawerOpen}
          onClose={toggleDrawer} // Close drawer when clicked outside or on menu item
          sx={{
            display: { xs: "block", sm: "none" }, // Show on mobile only
            [`& .MuiDrawer-paper`]: {
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
        >
          <List>
            <Box
              sx={{
                display: "flex",
                marginTop: 7,
                marginLeft: 2,
              }}
            >
              <img
                src={theme.palette.mode === "dark" ? scanologoWhite : scanologo}
                width={100}
                height={45}
                alt="Logo"
              />
            </Box>

            {/* Menu Items */}
            {menuItems.map((item) => (
              <ListItem
                key={item.text}
                component={Link}
                to={item.path}
                onClick={toggleDrawer}
                selected={location.pathname === item.path}
                sx={{
                  backgroundColor:
                    location.pathname === item.path
                      ? (theme) => theme.palette.primary.main
                      : "transparent",
                  color:
                    location.pathname === item.path
                      ? "#fff"
                      : (theme) => theme.palette.text.primary,
                  borderLeft:
                    location.pathname === item.path
                      ? `4px solid ${(theme) => theme.palette.primary.main}`
                      : "none",
                  "&:hover": {
                    backgroundColor:
                      location.pathname === item.path
                        ? (theme) => theme.palette.primary.main
                        : (theme) => theme.palette.action.hover,
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    color:
                      location.pathname === item.path
                        ? "#fff"
                        : (theme) => theme.palette.text.primary,
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItem>
            ))}
          </List>
        </Drawer>
      )}

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          padding: 3,
          marginLeft: !isLoginPage
            ? { sm: collapsed ? "60px" : `${drawerWidth}px` }
            : 0,
          transition: "margin 0.3s ease-in-out", // Smooth transition effect
          display: isLoginPage ? "flex" : "block",
          justifyContent: isLoginPage ? "center" : "initial",
          alignItems: isLoginPage ? "center" : "initial",
        }}
      >
        {isMobile && <Toolbar />}
        <Outlet />

        {location.pathname === "/dashboard" && (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
                p: 2,
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              <Title text="Dashboard" />

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: isMobile
                    ? "1fr"
                    : "repeat(auto-fit, minmax(270px, 1fr))",
                  gap: 4,
                  width: "100%",
                }}
              >
                <InfoCard
                  title="Total Patients"
                  count={userCount}
                  description="Total patients of all time"
                 
                  bgColor="primary.light"
                />

                <InfoCard
                  title="Total Scans"
                  count={scanCount}
                  description="Overall scan count" 
                  bgColor="secondary.light"
                />
               
              </Box>
              {Loader && <PageLoader />}
            </Box>
            {!isMobile && (
              <Box>
                <Box mb={2}>
                  <OverAllDaywise />
                </Box>
                <Box>
                  <OverAllMonthwise />
                </Box>
              </Box>
            )}
          </>
        )}
        <></>
      </Box>
    </Box>
  );
};

export default Dashboard;
